module.exports = __webpack_public_path__ + "img/AvatarImage.48c33dd0.png";